// extracted by mini-css-extract-plugin
module.exports = {"markdown":"pure-static-content_markdown__oofYD"};